var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1070_54960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 1.99955C11.5086 1.82445 11.7165 1.68556 11.9452 1.5908C12.174 1.49604 12.4192 1.44727 12.6668 1.44727C12.9145 1.44727 13.1597 1.49604 13.3884 1.5908C13.6172 1.68556 13.8251 1.82445 14.0002 1.99955C14.1753 2.17465 14.3142 2.38252 14.4089 2.61129C14.5037 2.84006 14.5524 3.08526 14.5524 3.33288C14.5524 3.58051 14.5037 3.8257 14.4089 4.05448C14.3142 4.28325 14.1753 4.49112 14.0002 4.66622L5.00016 13.6662L1.3335 14.6662L2.3335 10.9996L11.3335 1.99955Z",
    stroke: "#8B96A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1070_54960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.8e0394ed5f221fac5fdd549bad39c038.svg";
export { ForwardRef as ReactComponent };